<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-programa-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import {
  ESTADOS_PROGRAMAS_UNIVERSIDADES_COLORES,
  ESTADOS_PROGRAMAS_UNIVERSIDADES_LABELS,
  ModalidadesProgramasUniversidadesLabels,
} from '../utils/constantes';
import { cellRendererNumeroRegistro, cellRendererSiONo, formatearFechaCadena } from '../utils/funciones';

export default {
  name: 'ListadoProgramaUniversidad',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CODIGO',
          field: 'codigo',
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'PROGRAMA NOMBRE',
          field: 'programaNombre',
          minWidth: 500,
        },
        {
          headerName: 'MODALIDAD',
          field: 'modalidad',
          cellRenderer: (params) => {
            const modalidad = params.data?.modalidad;

            return ModalidadesProgramasUniversidadesLabels[modalidad] || '-';
          },
          valueGetter: (params) => {
            const modalidad = params.data?.modalidad;

            return ModalidadesProgramasUniversidadesLabels[modalidad] || '-';
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'TIENE CEUB',
          cellRenderer: cellRendererSiONo('ceubArchivoId', 'SI', 'NO'),
          filter: true,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'SEDE UNIVERSIDAD',
          field: 'sedeUniversidad.nombre',
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerName: 'UNIVERSIDAD',
          field: 'sedeUniversidad.institucion.nombre',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: (params) => {
            const estado = params.data?.estado;
            const color = ESTADOS_PROGRAMAS_UNIVERSIDADES_COLORES[estado] || 'grey';

            return /*html*/ `
              <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                  <span class="v-chip__content"> ${ESTADOS_PROGRAMAS_UNIVERSIDADES_LABELS[estado]} </span>
              </span>
            `;
          },
          valueGetter: (params) => {
            const estado = params.data?.estado;

            return ESTADOS_PROGRAMAS_UNIVERSIDADES_LABELS[estado];
          },
          minWidth: 220,
          maxWidth: 220,
        },
        {
          headerName: 'PLAN DE PAGO',
          cellRenderer: (params) => {
            return params.data?.planPagoUniversidad?.nombre || '-';
          },
          valueGetter: (params) => {
            return params.data?.planPagoUniversidad?.nombre || '-';
          },
          minWidth: 300,
        },
        {
          headerName: 'MÓDULOS',
          cellRenderer: (params) => {
            const modulosProgramasUniversidades = params.data?.modulosProgramasUniversidades || [];
            const cantidadModulos = modulosProgramasUniversidades.length;

            return cantidadModulos > 0 ? `${cantidadModulos} módulos` : 'Sin módulos';
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'GESTIÓN',
          field: 'gestion',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'RESOL. APROB. UNIV.',
          field: 'resolucionAprobacionUniversidad',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'VERSIÓN',
          field: 'version',
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ÁREA',
          field: 'areaUniversidad.nombre',
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'FECHA INICIO CEUB',
          cellRenderer: (params) => {
            return formatearFechaCadena(params.data?.fechaInicio) || '-';
          },
          valueGetter: (params) => {
            return params.data?.fechaInicio;
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'FECHA FIN CEUB',
          cellRenderer: (params) => {
            return formatearFechaCadena(params.data?.fechaFin) || '-';
          },
          valueGetter: (params) => {
            return params.data?.fechaFin;
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'TIPO',
          field: 'categoriaUniversidad.nombre',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'FECHA INSCRIPCIÓN',
          cellRenderer: (params) => {
            return params.data?.fechaInscripcion || '-';
          },
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'GRUPO',
          cellRenderer: (params) => {
            return params.data?.grupo || '-';
          },
          valueGetter: (params) => {
            return params.data?.grupo || '-';
          },
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-programa-universidad {
  height: calc(var(--vh, 1vh) * 100 - 15rem);
}
</style>
  